/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthorizationLeadScreenerLeadInfoRace
 */
export interface PalAuthorizationLeadScreenerLeadInfoRace {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfoRace
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfoRace
     */
    name?: string;
}

/**
 * Check if a given object implements the PalAuthorizationLeadScreenerLeadInfoRace interface.
 */
export function instanceOfPalAuthorizationLeadScreenerLeadInfoRace(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthorizationLeadScreenerLeadInfoRaceFromJSON(json: any): PalAuthorizationLeadScreenerLeadInfoRace {
    return PalAuthorizationLeadScreenerLeadInfoRaceFromJSONTyped(json, false);
}

export function PalAuthorizationLeadScreenerLeadInfoRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadScreenerLeadInfoRace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function PalAuthorizationLeadScreenerLeadInfoRaceToJSON(value?: PalAuthorizationLeadScreenerLeadInfoRace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

